import { AfterViewInit, Component, Input, OnDestroy, OnInit, QueryList, ViewChildren, OnChanges, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../../shared/commons/base-component/base.component';
import { Subscription } from 'rxjs/Subscription';
import { HelpersService } from '../../../../core/helpers/helpers.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ContentExtended } from '../../../../data/vod/models/contentExtended';
import { VodDataRestService } from '../../../../data/vod/vod-data-rest.service';
import { CategoryP } from '../../../../data/cms-vod-client-api';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentListResponse } from '../../../../data/cms-vod-client-api/model/contentListResponses';

// import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-video-slider',
  templateUrl: './video-slider.component.html',
  styleUrls: ['./video-slider.component.css']
})
export class VideoSliderComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input() contentID: number;
  @Input() categoryID: number;
  @Input() data: ContentListResponse[];
  contents: ContentListResponse[] = []
  isMobile: boolean;
  isDesktop: boolean;
  isTablet: boolean;
  slickSlider: any;
  categories: CategoryP[] = [];
  bannerMainboardElements: any;
  selectedCategoryID: number;
  mainCategory: CategoryP = {};

  @ViewChildren('bannerItems') bannerItems: QueryList<any>;
  private changeSubscription: Subscription;

  constructor(helpers: HelpersService,
    private deviceService: DeviceDetectorService,
    private restService: VodDataRestService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(helpers);
    this.isMobile = deviceService.isMobile()
    this.isDesktop = deviceService.isDesktop()
    this.isTablet = deviceService.isTablet()


  }

  ngOnInit() {
  }


  getCategories() {
    this.restService.getActiveCategories().subscribe(data => {
      this.categories = data;
      this.mainCategory = this.categories.find(item => item.main == true);
      this.findSelectedCategory();
    })
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    // REF: https://stackoverflow.com/questions/37087864/execute-a-function-when-ngfor-finished-in-angular-2
  }

  initSlider() {
    if (!!this.slickSlider) {
      this.slickSlider.slick("unslick");
      this.changeSubscription.unsubscribe();
    }

    // var thiz = this; 
    this.changeSubscription = this.bannerItems.changes.subscribe(t => {
      this.slickSlider = $('#banner-slider-' + this.contentID).slick({
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        speed: 1000,
        arrows: false
        // onInitialized: this.getCategories()
      });
    });

    // $('#banner-slider-' + this.contentID).on('reInit', function (slick) {
    //   console.log("reinitialized")
    // });
    // $('#banner-slider-' + this.contentID).on('destroy', function (event, slick) {
    //   console.log("desteroyed")
    // });
  }

  findSelectedCategory() {
    this.selectedCategoryID = +this.route.snapshot.paramMap.get('id');
    // if (this.selectedCategoryID != 0 && this.selectedCategoryID != -1) {
    //   this.changeColor(this.categories.find(item => item.id == this.selectedCategoryID))
    // }
    // else {
    //   this.changeColor(null);
    // }
  }

  changeColor(category: CategoryP) {
    this.bannerMainboardElements = document.getElementsByClassName('banner-content');
    if (!!category) {
      for (var i = 0; i < this.bannerMainboardElements.length; ++i) {
        this.bannerMainboardElements[i].style.background = `linear-gradient(transparent, ${category.backgroundColorCode}`;
      }
    }
    else {
      for (var i = 0; i < this.bannerMainboardElements.length; ++i) {
        this.bannerMainboardElements[i].style.background = `linear-gradient(transparent, ${this.mainCategory.backgroundColorCode}`;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && !changes.data.isFirstChange()) {
      this.contents = this.data;
      // this.setPosters();
      this.initSlider();
      this.getCategories();
    }
  }

  ngOnDestroy(): void {

    if (this.changeSubscription) {
      this.changeSubscription.unsubscribe();
      this.changeSubscription = null;
    }
  }

  clickBanner(mainboardItem: ContentListResponse) {
    if (this.isMobile) {
      this.router.navigate(['/contentDetail', mainboardItem.id, mainboardItem.urlName]);
    }
  }




}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/widgets/video-slider/video-slider.component.ts